import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { ALLERGENS_QUERY } from '../graphql/queries'
import { FETCH_ALLERGENS } from '../redux/action-types'
import { cleanupFetchAllergens } from '../redux/actions'

const useAllergensQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchAllergens)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.allergens.allergens,
  )

  const refetch = useCallback(
    () => apolloService.query(ALLERGENS_QUERY, {}, dispatch, FETCH_ALLERGENS),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, initialData, latestEvent }
}

export default useAllergensQuery
